import clsx from 'clsx';
import Skeleton from 'antd/es/skeleton';
import Spin from 'antd/es/spin';

export type ContainerLoaderProps = {
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
  tip?: string;
  showSkeleton?: boolean;
  skeletonRows?: number;
  skeletonClassName?: string;
};

/**
 * Hiển thị trạng thái loading trong phạm vi của một container/section,
 * không khóa toàn bộ màn hình như Spinner global.
 */
export const ContainerLoader = ({
  loading = false,
  children,
  className = '',
  tip = 'Loading...',
  showSkeleton = true,
  skeletonRows = 8,
  skeletonClassName = 'p-4',
}: ContainerLoaderProps) => {
  if (!loading) {
    return <>{children}</>;
  }

  return (
    <div className={clsx('relative w-full h-full min-h-[120px]', className)}>
      {showSkeleton && (
        <Skeleton
          active
          paragraph={{ rows: skeletonRows }}
          className={skeletonClassName}
        />
      )}
      <div
        className='absolute inset-0 z-10 flex items-center justify-center bg-black/5 rounded-lg'
        aria-busy='true'
        aria-live='polite'
      >
        <Spin tip={tip} size='large' />
      </div>
    </div>
  );
};
